import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ForwarderPageNavigation from "forwarder/ForwarderPageNavigation";
import { DocumentTitle, PageHeader } from "components/common";
import { Col, Row } from "components/bootstrap";
import ForwarderDocs from "forwarder/util/ForwarderDocs";
import useHistory from "routing/useHistory";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ForwarderRoutes from "forwarder/Routes";
import { InputProfilesActions } from "./stores/InputProfilesStore";
import withIsPermitted from "./util/withIsPermitted";
import InputProfileForm from "./input-profiles/InputProfileForm";
const REQUIRED_PERMISSIONS = ["inputprofiles:create"];
const StyledH2 = styled.h2`
  margin-bottom: 20px;
`;
const NewInputProfilePage = () => {
  const { t } = useTranslation("enterprise_forwarder");
  const history = useHistory();
  const sendTelemetry = useSendTelemetry("input-profile");
  const _handleInputProfileCreation = (inputProfile) => {
    history.push(ForwarderRoutes.PROFILE.details(inputProfile.id));
  };
  const _handleSubmit = (nextInputProfile) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_INPUT_PROFILE_CREATED, {
      app_pathname: "forwarder"
    });
    InputProfilesActions.create(nextInputProfile).then((result) => {
      _handleInputProfileCreation(result);
      return result;
    });
  };
  const _handleCancel = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_INPUT_PROFILE_CREATE_CANCELED, {
      app_pathname: "forwarder"
    });
    history.push(ForwarderRoutes.PROFILE.LIST);
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("new_input_profile_page.title") }, /* @__PURE__ */ React.createElement(ForwarderPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("new_input_profile_page.title"),
      documentationLink: {
        title: t("common.input_profile_documentation"),
        path: ForwarderDocs.INPUT_PROFILE
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("new_input_profile_page.description"))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 7 }, /* @__PURE__ */ React.createElement(StyledH2, null, t("new_input_profile_page.details_heading")), /* @__PURE__ */ React.createElement(InputProfileForm, { onCancel: _handleCancel, onSubmit: _handleSubmit, buttonText: t("common.create") }))));
};
export default withIsPermitted(NewInputProfilePage, REQUIRED_PERMISSIONS);
